import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('partnerToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('partnerToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  getMe: () => api.get('/auth/me'),
};

export const rewardsAPI = {
  getMyRewards: () => api.get('/partners/my-rewards'),
  createReward: (data) => api.post('/rewards', data),
  updateReward: (id, data) => api.put(`/rewards/${id}`, data),
  deleteReward: (id) => api.delete(`/rewards/${id}`),
};

export const analyticsAPI = {
  getMyStats: () => api.get('/partners/my-stats'),
  getRedemptions: (params) => api.get('/partners/redemptions', { params }),
};
